// extracted by mini-css-extract-plugin
export var standaloneTable = "_fz-0";
export var withExtraHeader = "_fz-1";